import React, { Component } from 'react';
import { Row, Col, Input } from 'react-materialize';
import { Slider } from 'antd';
import { Card, Image, Modal, Tab, Pagination } from 'semantic-ui-react';
import ImageGallery from 'react-image-gallery';
import '../css/types.css';
import '../css/antd.css';
import { getTitleRetention } from './constants';
import { Calculator } from './calculator';
import { HOSTNAME } from '../config.js';

class Types extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      itemPerPage: 6,
      data : [],
      section: [],
      group: [],
      stand: [],
      filterStep_1: '1.0',
      filterStep_2: '1.5',
      filterStep_3: '2.0',
      filterStep_4: '2.5',
      filterStep_5: '3.0',
      filterStep_6: '4.0',
      filterBalk_1: '1',
      filterBalk_2: '2',
      filterBalk_3: '3',
      filterImpactEnergyMin: 130,
      filterImpactEnergyMax: 400,
      filterDynamicDeflectionMin: 0,
      filterDynamicDeflectionMax: 1.3,
      filterHeightMin: 0.7,
      filterHeightMax: 1.3,
      filterWeightMin: 2.0,
      filterWeightMax: 3.0,
      filterTypeRoad: 'road',
      filterTypeBridge: 'bridge',
      filterTypeSideOne: '1',
      filterTypeSideTwo: '2',
      current_id: 0,
      current_title: '',
      current_img: '',
      current_type: '',
      current_impact: '',
      current_height: '',
      current_mark: '',
      current_step: '',
      current_balkCount: '',
      current_dynamicDeflection: '',
      current_workingWidth: '',
      current_weight: '',
      current_section: '',
      current_countTier: '',
      current_sketchfab_id: '',
      open: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchData();
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

  openModal(e) {
    this.setState({open: true});
    let id;

    if (e) {
      id = e.target.getAttribute("rel");
    } else {
      let url = this.props.location.pathname.split('/');
      id = parseInt(url[url.length - 1], 10);
    }

    if (id === null) {
      return;
    }

    let data = this.state.data;
    let current_title, current_img, current_type, current_impact, current_height, current_mark, current_step, current_balkCount, current_dynamicDeflection, current_workingWidth, current_weight, current_section, group_id, stand_id, top_section_id, mid_section_id, low_section_id, top_section, mid_section, low_section, sketchfab_id;

    let flag = true;
    if (data.length > 0) {
      for (let i in data) {
        if ((parseInt(data[i].id, 10) == id) && (flag)) {
          group_id = data[i].group_id;
          stand_id = data[i].stand_id;
          top_section_id = data[i].top_section;
          mid_section_id = data[i].mid_section;
          low_section_id = data[i].low_section;
          sketchfab_id = data[i].sketchfab_id;
          current_workingWidth = data[i].workingWidth;
          flag = false;
        }
      }

      let group = this.state.group;
      let stand = this.state.stand;
      let section = this.state.section;

      let bg_shortname = "";
      for (let i in group) {
        if (group[i].id === group_id) {
          bg_shortname = group[i].shortname;
        }
      }

      let bg_name = "";
      for (let i in group) {
        if (group[i].id === group_id) {
          bg_name = group[i].name;
        }
      }

      let stand_mark = "";
      for (let i in stand) {
        if (stand[i].id === stand_id) {
          stand_mark = stand[i].mark;
        }
      }

      let count_tier = 0;

      if (top_section_id !== 'null') {
        for (let i in section) {
          if (section[i].id === top_section_id) {
            top_section = section[i].mark;
            count_tier++;
          }
        }
      }

      if (mid_section_id !== 'null') {
        for (let i in section) {
          if (section[i].id === mid_section_id) {
            mid_section = section[i].mark;
            count_tier++;
          }
        }
      }

      if (low_section_id !== 'null') {
        for (let i in section) {
          if (section[i].id === low_section_id) {
            low_section = section[i].mark;
            count_tier++;
          }
        }
      }

      let stop = false;

      for (let i in data) {
        if (parseInt(data[i].id, 10) == id) {
          let stat_title = getTitleRetention(data[i].impact_energy);

          current_title = `${bg_shortname} / ${data[i].impact_energy} - ${data[i].height} - ${data[i].stand_step} ÷ ${data[i].dynamic_deflection} (${current_workingWidth}) ${stat_title} (${stand_mark}) - #${id}`;

          current_img = data[i].image;
          current_type = `${bg_shortname} (${bg_name})`;
          current_impact = `${stat_title} (${data[i].impact_energy} кДж)`;
          current_height = `${data[i].height} м`;
          current_mark = stand_mark;
          current_step = `${data[i].stand_step} м`;
          current_balkCount = data[i].balk;
          current_dynamicDeflection = `${data[i].dynamic_deflection} м`;
          current_workingWidth = `${data[i].workingWidth} м`;
          if (data[i].weight !== '0.0') {
            current_weight = `${data[i].weight} кг`;
          } else {
            current_weight = 'не указан';
          }

          current_section = '';
          if (top_section) {
            current_section += top_section + " ";
          }

          if (mid_section) {
            current_section += mid_section  + " ";
          }

          if (low_section) {
            current_section += low_section;
          }

          break;
        }
      }

      this.setState({current_id: id});
      this.setState({current_title: current_title});
      this.setState({current_img: current_img});
      this.setState({current_type: current_type});
      this.setState({current_impact: current_impact});
      this.setState({current_height: current_height});
      this.setState({current_mark: current_mark});
      this.setState({current_step: current_step});
      this.setState({current_balkCount: current_balkCount});
      this.setState({current_dynamicDeflection: current_dynamicDeflection});
      this.setState({current_workingWidth: current_workingWidth});
      this.setState({current_weight: current_weight});
      this.setState({current_section: current_section});
      this.setState({current_countTier: count_tier});
      this.setState({current_sketchfab_id: sketchfab_id});
    }
  }

  closeModal() {
    document.body.classList.remove("no-scroll");
    this.setState({open: false});
  }

  changeFilterStep_1 = (e) => {
    if (this.state.filterStep_1 === '') {
      this.setState({filterStep_1: e.target.value});
    } else {
      this.setState({filterStep_1: ''});
    }
  }

  changeFilterStep_2 = (e) => {
    if (this.state.filterStep_2 === '') {
      this.setState({filterStep_2: e.target.value});
    } else {
      this.setState({filterStep_2: ''});
    }
  }

  changeFilterStep_3 = (e) => {
    if (this.state.filterStep_3 === '') {
      this.setState({filterStep_3: e.target.value});
    } else {
      this.setState({filterStep_3: ''});
    }
  }

  changeFilterStep_4 = (e) => {
    if (this.state.filterStep_4 === '') {
      this.setState({filterStep_4: e.target.value});
    } else {
      this.setState({filterStep_4: ''});
    }
  }

  changeFilterStep_5 = (e) => {
    if (this.state.filterStep_5 === '') {
      this.setState({filterStep_5: e.target.value});
    } else {
      this.setState({filterStep_5: ''});
    }
  }

  changeFilterStep_6 = (e) => {
    if (this.state.filterStep_6 === '') {
      this.setState({filterStep_6: e.target.value});
    } else {
      this.setState({filterStep_6: ''});
    }
  }

  changeFilterBalk_1 = (e) => {
    if (this.state.filterBalk_1 === '') {
      this.setState({filterBalk_1: e.target.value});
    } else {
      this.setState({filterBalk_1: ''});
    }
  }

  changeFilterBalk_2 = (e) => {
    if (this.state.filterBalk_2 === '') {
      this.setState({filterBalk_2: e.target.value});
    } else {
      this.setState({filterBalk_2: ''});
    }
  }

  changeFilterBalk_3 = (e) => {
    if (this.state.filterBalk_3 === '') {
      this.setState({filterBalk_3: e.target.value});
    } else {
      this.setState({filterBalk_3: ''});
    }
  }

  changeFilterImpactEnergy = (e) => {
    this.setState({filterImpactEnergyMin: e[0]});
    this.setState({filterImpactEnergyMax: e[1]});
  }

  changeFilterDynamicDeflection = (e) => {
    this.setState({filterDynamicDeflectionMin: e[0]});
    this.setState({filterDynamicDeflectionMax: e[1]});
  }

  changeFilterHeight = (e) => {
    this.setState({filterHeightMin: e[0]});
    this.setState({filterHeightMax: e[1]});
  }

  changeFilterWeight = (e) => {
    this.setState({filterWeightMin: e[0]});
    this.setState({filterWeightMax: e[1]});
  }

  changeFilterTypeRoad = (e) => {
    if (this.state.filterTypeRoad === '') {
      this.setState({filterTypeRoad: e.target.value});
    } else {
      this.setState({filterTypeRoad: ''});
    }
  }

  changeFilterTypeBridge = (e) => {
    if (this.state.filterTypeBridge === '') {
      this.setState({filterTypeBridge: e.target.value});
    } else {
      this.setState({filterTypeBridge: ''});
    }
  }

  changeFilterTypeSideOne = (e) => {
    if (this.state.filterTypeSideOne === '') {
      this.setState({filterTypeSideOne: e.target.value});
    } else {
      this.setState({filterTypeSideOne: ''});
    }
  }

  changeFilterTypeSideTwo = (e) => {
    if (this.state.filterTypeSideTwo === '') {
      this.setState({filterTypeSideTwo: e.target.value});
    } else {
      this.setState({filterTypeSideTwo: ''});
    }
  }

  fetchData() {
    fetch(HOSTNAME + 'api.php/section?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.section.map(section => (
      {
        id: `${section.id}`,
        mark: `${section.mark}`,
        length: `${section.length}`,
        width: `${section.width}`,
        height: `${section.height}`,
        thickness: `${section.thickness}`,
        radius: `${section.radius}`
      }
    )))
    .then(section => this.setState({section}))
    .catch(error => console.log('fetch section error', error));

    fetch(HOSTNAME + 'api.php/barrier_group?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.barrier_group.map(group => (
      {
        id: `${group.id}`,
        name: `${group.name}`,
        shortname: `${group.shortname}`,
        sides: `${group.sides}`,
        type: `${group.type}`,
        base: `${group.base}`
      }
    )))
    .then(group => this.setState({group}))
    .catch(error => console.log('fetch group error', error));

    fetch(HOSTNAME + 'api.php/stand?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.stand.map(stand => (
    {
      id: `${stand.id}`,
      mark: `${stand.mark}`,
      profile: `${stand.profile}`,
      length: `${stand.length}`
    }
    )))
    .then(stand => this.setState({stand}))
    .catch(error => console.log('fetch stand error', error));


    let that = this;
    fetch(HOSTNAME + 'api.php/barrier?transform=1&include=barrier_image,barrier_stat')
    .then(response => response.json())
    .then(parsedJson => parsedJson.barrier.map(barrier => (
      {
        id: `${barrier.id}`,
        group_id: `${barrier.group_id}`,
        stand_id: `${barrier.stand_id}`,
        impact_energy: `${barrier.impact_energy}`,
        height: `${barrier.height}`,
        stand_step: `${barrier.stand_step}`,
        dynamic_deflection: `${barrier.dynamic_deflection}`,
        stand_mark: `${barrier.stand_mark}`,
        image: `${barrier.barrier_image.map(item => item.filename)}`,
        stat: `${barrier.barrier_stat.map(item => item.count)}`,
        balk: `${barrier.balk_count}`,
        workingWidth: `${barrier.working_width}`,
        weight: `${barrier.weight}`,
        top_section: `${barrier.top_section}`,
        mid_section: `${barrier.mid_section}`,
        low_section: `${barrier.low_section}`,
        sketchfab_id: `${barrier.sketchfab_id}`,
      }
    )))
    .then(function(data){
      that.setState({
        data: data
      }, () => {
        let url = that.props.location.pathname;
        let id = url.split('/');
        id = parseInt(id[id.length - 1], 10);

        that.setState({data: data});
        that.setState({current_id: id});

        if (!isNaN(id)) {
          setTimeout(that.openModal(), 15000);
        }
      });
    })
    .catch(error => console.log('fetch data error', error));
  }

  render() {
    let indexOfLastTodo = this.state.activePage * this.state.itemPerPage;
    let indexOfFirstTodo = indexOfLastTodo - this.state.itemPerPage;
    const { open, activePage } = this.state;
    let barrier = this.state.data.slice();

    // filter Impact Energy
    let filterImpactEnergyMin = this.state.filterImpactEnergyMin;
    filterImpactEnergyMin = barrier.filter(function(stuff){
      if (parseInt(stuff.impact_energy, 10) >= parseInt(filterImpactEnergyMin, 10)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterImpactEnergyMin;

    let filterImpactEnergyMax = this.state.filterImpactEnergyMax;
    filterImpactEnergyMax = barrier.filter(function(stuff){
      if (parseInt(stuff.impact_energy, 10) < parseInt(filterImpactEnergyMax, 10)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterImpactEnergyMax;

    // filter Dynamic Deflection
    let filterDynamicDeflectionMin = this.state.filterDynamicDeflectionMin;
    filterDynamicDeflectionMin = barrier.filter(function(stuff){
      if (parseFloat(stuff.dynamic_deflection) >= parseFloat(filterDynamicDeflectionMin)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterDynamicDeflectionMin;

    let filterDynamicDeflectionMax = this.state.filterDynamicDeflectionMax;
    filterDynamicDeflectionMax = barrier.filter(function(stuff){
      if (parseFloat(stuff.dynamic_deflection) < parseFloat(filterDynamicDeflectionMax)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterDynamicDeflectionMax;

    //filter Step
    let filterStep_1 = this.state.filterStep_1;
    let filterStep_2 = this.state.filterStep_2;
    let filterStep_3 = this.state.filterStep_3;
    let filterStep_4 = this.state.filterStep_4;
    let filterStep_5 = this.state.filterStep_5;
    let filterStep_6 = this.state.filterStep_6;
    filterStep_1 = barrier.filter(bar => bar.stand_step === this.state.filterStep_1);
    filterStep_2 = barrier.filter(bar => bar.stand_step === this.state.filterStep_2);
    filterStep_3 = barrier.filter(bar => bar.stand_step === this.state.filterStep_3);
    filterStep_4 = barrier.filter(bar => bar.stand_step === this.state.filterStep_4);
    filterStep_5 = barrier.filter(bar => bar.stand_step === this.state.filterStep_5);
    filterStep_6 = barrier.filter(bar => bar.stand_step === this.state.filterStep_6);
    barrier = filterStep_1.concat(filterStep_2).concat(filterStep_3).concat(filterStep_4).concat(filterStep_5).concat(filterStep_6);

    //filter Height
    let filterHeightMin = this.state.filterHeightMin;
    filterHeightMin = barrier.filter(function(stuff){
      if (parseFloat(stuff.height) >= parseFloat(filterHeightMin)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterHeightMin;

    let filterHeightMax = this.state.filterHeightMax;
    filterHeightMax = barrier.filter(function(stuff){
      if (parseFloat(stuff.height) < parseFloat(filterHeightMax)) {
        return stuff;
      } else {
        return false;
      }
    });
    barrier = filterHeightMax;

    //filter Balk
    let filterBalk_1 = this.state.filterBalk_1;
    let filterBalk_2 = this.state.filterBalk_2;
    let filterBalk_3 = this.state.filterBalk_3;
    filterBalk_1 = barrier.filter(stuff => stuff.balk === this.state.filterBalk_1);
    filterBalk_2 = barrier.filter(stuff => stuff.balk === this.state.filterBalk_2);
    filterBalk_3 = barrier.filter(stuff => stuff.balk === this.state.filterBalk_3);
    barrier = filterBalk_1.concat(filterBalk_2).concat(filterBalk_3);

    //filter Type
    let filterTypeRoad = this.state.filterTypeRoad;
    if (filterTypeRoad === 'road') {
      //filterTypeRoad = barrier.filter(bar => ((bar.group_id === '1') || (bar.group_id === '2')));
      filterTypeRoad = barrier;
    }

    let filterTypeBridge = this.state.filterTypeBridge;
    if (filterTypeBridge === 'bridge') {
      filterTypeBridge = barrier.filter(bar => ((bar.group_id === '3') || (bar.group_id === '4') || (bar.group_id === '5') || (bar.group_id === '6')));
    }

    if ((filterTypeRoad.length > 0) && (filterTypeBridge.length > 0)) {
      barrier = filterTypeRoad.concat(filterTypeBridge);
      barrier = barrier.concat();
      for (let i = 0; i < barrier.length; ++i) {
        for (let j = i + 1; j < barrier.length; ++j) {
          if (barrier[i] === barrier[j]) {
            barrier.splice(j--, 1);
          }
        }
      }
    } else if (filterTypeRoad.length > 0) {
      barrier = filterTypeRoad;
    } else if (filterTypeBridge.length > 0) {
      barrier = filterTypeBridge;
    } else {
      barrier = '';
    }

    if (barrier) {
      //filter Sides
      let group = this.state.group;
      let filterTypeSideOne = this.state.filterTypeSideOne;

      if (filterTypeSideOne === '1') {
        filterTypeSideOne = barrier.filter(function(barrier) {
          for (let i in group) {
            if (group[i].id === barrier.group_id) {
              if (parseInt(group[i].sides, 10) === 1) {
                return barrier;
              }
            }
          }
          return false;
        })
      }

      let filterTypeSideTwo = this.state.filterTypeSideTwo;

      if (filterTypeSideTwo === '2') {
        filterTypeSideTwo = barrier.filter(function(barrier) {
          for (let i in group) {
            if (group[i].id === barrier.group_id) {
              if (parseInt(group[i].sides, 10) === 2) {
                return barrier;
              }
            }
          }
          return false;
        })
      }

      if ((filterTypeSideOne.length > 0) && (filterTypeSideTwo.length > 0)) {
        barrier = filterTypeSideOne.concat(filterTypeSideTwo);
        barrier = barrier.concat();
        for (let i = 0; i < barrier.length; ++i) {
          for (let j = i + 1; j < barrier.length; ++j) {
            if (barrier[i] === barrier[j]) {
              barrier.splice(j--, 1);
            }
          }
        }
      } else if (filterTypeSideOne.length > 0) {
        barrier = filterTypeSideOne;
      } else if (filterTypeSideTwo.length > 0) {
        barrier = filterTypeSideTwo;
      } else {
        barrier = '';
      }
    }

    let totalPages = Math.ceil(barrier.length / this.state.itemPerPage);
    let panes = [
      { menuItem: 'Галерея', render: () =>
        {
          let images = [];
          if (this.state.current_img) {
            images = this.state.current_img.split(',');
          } else {
            images.push("no-image.jpg");
          }


          let gallery = [];

          for (let i = 0; i < images.length; i++) {

            let galleryItem = {
              original: `${HOSTNAME}img/barrier_image/${images[i]}`
            }

            gallery.push(galleryItem);
          }
          return (
            <Tab.Pane attached={false}>
              <ImageGallery items={gallery} showThumbnails={false} showFullscreenButton={false} showPlayButton={false} />
            </Tab.Pane>
          )
        }
      }
    ];

    if (this.state.current_sketchfab_id) {
      panes.push({ menuItem: '3D', render: () =>
        <Tab.Pane attached={false}>
          <div className="sketchfab-embed-wrapper">
            <iframe title="sketchfab" src={`https://sketchfab.com/models/${this.state.current_sketchfab_id}/embed?autostart=1`} frameBorder="0" allow="autoplay; fullscreen; vr" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
          </div>
        </Tab.Pane>
      })
    }

    panes.push({ menuItem: 'Калькулятор', render: () =>
      <Tab.Pane attached={false}>
        <Calculator id={this.state.current_id}/>
      </Tab.Pane>
    })

    let dataTable = (
      <Col s={6}>
        <table className='modal-table'>
          <tbody>
            <tr>
              <td>Тип ограждения</td>
              <td>{this.state.current_type}</td>
            </tr>
            <tr>
              <td>Удерживающая способность</td>
              <td>{this.state.current_impact}</td>
            </tr>
            <tr>
              <td>Высота комплекта</td>
              <td>{this.state.current_height}</td>
            </tr>
            <tr>
              <td>Марка стойки</td>
              <td>{this.state.current_mark}</td>
            </tr>
            <tr>
              <td>Шаг стоек</td>
              <td>{this.state.current_step}</td>
            </tr>
            <tr>
              <td>Количество ярусов</td>
              <td>{this.state.current_countTier}</td>
            </tr>
            <tr>
              <td>Секции балок</td>
              <td>{this.state.current_section}</td>
            </tr>
            <tr>
              <td>Динамический прогиб</td>
              <td>{this.state.current_dynamicDeflection}</td>
            </tr>
            <tr>
              <td>Рабочая ширина</td>
              <td>{this.state.current_workingWidth}</td>
            </tr>
            <tr>
              <td>Вес 1 м/п ограждения</td>
              <td>{this.state.current_weight}</td>
            </tr>
          </tbody>
        </table>
      </Col>
    )

    return(
      <div className="types-wrapper">
        <Row>
          <Col s={12} m={4}>
            <div className="filter-panel">
              <Col s={12} m={12} l={6}>
                <Input name='group1' type='checkbox' value='road' label='Дорожное' onChange={this.changeFilterTypeRoad} checked />
                <Input name='group1' type='checkbox' value='bridge' label='Мостовое' onChange={this.changeFilterTypeBridge} checked />
              </Col>
              <Col s={12} m={12} l={6}>
                <Input name='group1' type='checkbox' value='1' label='Одностороннее' onChange={this.changeFilterTypeSideOne} checked />
                <Input name='group1' type='checkbox' value='2' label='Двустороннее' onChange={this.changeFilterTypeSideTwo} checked />
              </Col>
              <div className="clearfix"></div>
              <div className='range'>
                <p className="range-field">Удерживающая способность:</p>
                <Slider
                  range
                  step={10}
                  min={130}
                  max={600}
                  defaultValue={[this.state.filterImpactEnergyMin, this.state.filterImpactEnergyMax]}
                  onChange={this.changeFilterImpactEnergy} />
              </div>
              <div className="clearfix"></div>
              <div className='range'>
                <p className="range-field">Динамический прогиб:</p>
                <Slider
                  range
                  step={0.01}
                  min={0}
                  max={2}
                  defaultValue={[this.state.filterDynamicDeflectionMin, this.state.filterDynamicDeflectionMax]}
                  onChange={this.changeFilterDynamicDeflection} />
              </div>
              <div className="clearfix"></div>
              <Col s={12}>
                <p className="range-field">Шаг стоек:</p>
                <Input name='group1' type='checkbox' value='1.0' label='1 м' onChange={this.changeFilterStep_1} checked />
                <Input name='group1' type='checkbox' value='1.5' label='1,5 м' onChange={this.changeFilterStep_2} checked />
                <Input name='group1' type='checkbox' value='2.0' label='2 м' onChange={this.changeFilterStep_3} checked />
                <Input name='group1' type='checkbox' value='2.5' label='2,5 м' onChange={this.changeFilterStep_4} checked />
                <Input name='group1' type='checkbox' value='3.0' label='3 м' onChange={this.changeFilterStep_5} checked />
                <Input name='group1' type='checkbox' value='4.0' label='4 м' onChange={this.changeFilterStep_6} checked />
              </Col>
              <div className="clearfix"></div>
              <div className='range'>
                <p className="range-field">Высота комплекта:</p>
                <Slider
                  range
                  step={0.05}
                  min={0.7}
                  max={1.55}
                  defaultValue={[this.state.filterHeightMin, this.state.filterHeightMax]}
                  onChange={this.changeFilterHeight} />
              </div>
              <div className="clearfix"></div>
              <Col s={12}>
                <p>Количество ярусов:</p>
                <Input name='group1' type='checkbox' value='1' label='1' onChange={this.changeFilterBalk_1} checked />
                <Input name='group1' type='checkbox' value='2' label='2' onChange={this.changeFilterBalk_2} checked />
                <Input name='group1' type='checkbox' value='3' label='3' onChange={this.changeFilterBalk_3} checked />
                <div className="clearfix"></div>
              </Col>
            </div>
          </Col>
          <Col s={12} m={8}>
            <div className="fence">
              {
                barrier.length > 0 ? barrier.slice(indexOfFirstTodo, indexOfLastTodo).map(barrier_ => {
                  let {id, impact_energy, height, stand_step, dynamic_deflection, workingWidth, stat, group_id, stand_id} = barrier_;
                  let image = barrier_.image.split(',');
                  image = image[0];

                  if (image === '') {
                    image = 'no-image-min.jpg';
                  }
                  let stat_title = getTitleRetention(impact_energy);

                  let bg_shortname = '';
                  for (let i in this.state.group) {
                    if (this.state.group[i].id === group_id) {
                      bg_shortname = this.state.group[i].shortname;
                    }
                  }

                  let stand_mark = '';
                  for (let i in this.state.stand) {
                    if (this.state.stand[i].id === stand_id) {
                      stand_mark = this.state.stand[i].mark;
                    }
                  }

                  return (
                    <Card className='types-card' onClick={this.openModal.bind(this)} key={id} rel={id}>
                      <Image src={`${HOSTNAME}img/barrier_image/${image}`} rel={id} alt={id}/>
                      <Card.Content>
                        <Card.Header>
                          <p rel={id}>{bg_shortname} / {impact_energy} - {height} - {stand_step} ÷ {dynamic_deflection} ({workingWidth}) {stat_title} ({stand_mark}) #{id}</p>
                        </Card.Header>
                      </Card.Content>
                    </Card>
                  )
                }) : null
              }
            </div>
            <Pagination defaultActivePage={activePage} onPageChange={this.handlePaginationChange} totalPages={totalPages} />
          </Col>
        </Row>

        <Modal open={open} onClose={this.closeModal}>
          <div>
            <h4>{this.state.current_title}</h4>
            <Row>
              <Col s={12} m={6} l={12} className="image">
                <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
              </Col>
              {dataTable}
            </Row>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Types;



// WEBPACK FOOTER //
// ./src/components/types.js